// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "label.fancyCheckboxLabel[data-v-ec1ad0c8]{padding-left:15px !important}label.fancyCheckboxLabel[data-v-ec1ad0c8]::before{min-width:2.2em !important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
